
import * as storyblokRuntime$ee4oN6fo0KAK0lcQZqQDwafSxClc3K1TnLeoaoXpnAc from '/app/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "listRow": {
      "modifiers": {
        "width": 48,
        "height": 48
      }
    },
    "listColumn": {
      "modifiers": {
        "width": 310,
        "height": 310
      }
    },
    "detailHeader": {
      "modifiers": {
        "width": 128,
        "height": 128
      }
    },
    "myLibraryItem": {
      "modifiers": {
        "width": 40,
        "height": 40
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "s3-eu-west-1.amazonaws.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$ee4oN6fo0KAK0lcQZqQDwafSxClc3K1TnLeoaoXpnAc, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} }
}
        